import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || '/api',
  timeout: 30000
});

api.interceptors.request.use(config => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  response => response,
  error => {
    if (error.response?.status === 401) {
      // ⚠️ 2026-10-16：先提示再跳登录（原来静默跳转，用户以为“卡住了/一直转圈”）
      const _onLogin = window.location.pathname === '/login';
      if (!_onLogin) {
        try {
          // eslint-disable-next-line no-alert
          alert('登录已过期，请重新登录');
        } catch (e) { /* ignore */ }
        localStorage.clear();
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

/**
 * 敏感文件（/uploads、/archive）鉴权
 *
 * ⚠️ 2026-10-23 合规整改：
 *   旧：`/uploads/x.jpg?token=<7天登录token>`
 *       → URL 会进 Nginx 日志 / 浏览器历史 / 转发链接
 *       → 等于泄露完整账号权限（不止看这张图）
 *   新：`/uploads/x.jpg?_e=1730&_s=abc`（文件级 5 分钟签名）
 *       → 真现由 utils/fileSign.js 实现，调用方式完全不变
 *
 * 保留此导出是为了不破坏现有 16 处调用点。
 */
export {
  fileUrl,
  warmupFileUrls,
  onFileSigReady,
  clearFileSigCache,
  isFileUrlReady,
} from './fileSign';

export default api;
